/* eslint-disable max-len */
import { useEffect } from 'react';
import { type StandardApplicationEntrypointContextDataFragment } from '../../../../api/fragments/StandardApplicationEntrypointContextData';
import { type StandardApplicationPublicAccessEntrypointContextDataFragment } from '../../../../api/fragments/StandardApplicationPublicAccessEntrypointContextData';
import { useDealerContext, useSingleDealerId } from '../../../../components/contexts/DealerContextManager';
import useTranslatedString from '../../../../utilities/useTranslatedString';
import CarListingPageInner from './CarListingPageInner';
import CarListingStateProvider from './useCarListingState';

export type CarListingPageProps = {
    endpoint:
        | StandardApplicationEntrypointContextDataFragment
        | StandardApplicationPublicAccessEntrypointContextDataFragment;
};

const CarListingPage = ({ endpoint }: CarListingPageProps) => {
    const { dealerId } = useSingleDealerId();
    const { setDealerOptions, dealersFromApi, setAllVisible } = useDealerContext();
    const translated = useTranslatedString();

    useEffect(() => {
        if (dealersFromApi.length > 0) {
            const dealerOption = dealersFromApi.map(dealer => ({
                value: dealer.id,
                label: translated(dealer.legalName),
            }));
            setDealerOptions(dealerOption);
        }
        setAllVisible();
    }, []);

    return (
        <CarListingStateProvider dealerIds={[dealerId]} endpoint={endpoint}>
            <CarListingPageInner dealerIds={[dealerId]} />
        </CarListingStateProvider>
    );
};

export default CarListingPage;
